import type { PluginListenerHandle } from '@capacitor/core';

export interface CallActionEvent {
  action: 'accepted' | 'rejected';
  username: string;
  callId: string;
  roomName?: string;
}

export interface CallScreenPlugin {
  showCallScreen(options: { username: string; callId?: string; roomName?: string }): Promise<void>;
  handleIncomingCall(options: { username: string; callId?: string; roomName?: string }): Promise<void>;
  stopCall(): Promise<void>;
  isCallActive(): Promise<{ isActive: boolean }>;
  addListener(eventName: 'callAction', listenerFunc: (event: CallActionEvent) => void): Promise<PluginListenerHandle>;
  removeAllListeners(eventName: 'callAction'): Promise<void>;
}
